module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/Tabs/images/tab-hover.70a37fc1.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Tabs/images/tab-hover.png
// module id = 3240
// module chunks = 11